export default "__VITE_ASSET__CS_629JI__"